/**
 * What Moo says while the request is out and nothing has come back yet:
 * whimsical gerunds, some real, some made up. They describe a mood, never an
 * action — a phrase like "Checking for MFA" would claim work Moo is not
 * doing. This is the original list, plus a few inventions in its spirit.
 */
export const WAITING_VERBS: readonly string[] = [
  // Insurance / underwriting
  'Underwriting',
  'Evaluating',
  'Assessing',
  'Reviewing',
  'Analyzing',
  'Appraising',
  'Auditing',
  'Triaging',
  'Adjudicating',
  'Classifying',
  'Benchmarking',
  'Vetting',
  'Scrutinizing',

  // Playful / whimsical
  'Incubating',
  'Percolating',
  'Manifesting',
  'Germinating',
  'Conjuring',
  'Ruminating',
  'Noodling',
  'Marinating',
  'Simmering',
  'Fermenting',
  'Daydreaming',
  'Contemplating',
  'Meditating',
  'Musing',
  'Mulling',
  'Pondering',
  'Cogitating',
  'Philosophizing',

  // Technical
  'Computing',
  'Processing',
  'Synthesizing',
  'Compiling',
  'Resolving',
  'Crunching',
  'Indexing',
  'Correlating',
  'Aggregating',
  'Interpolating',
  'Deciphering',
  'Parsing',
  'Optimizing',

  // Creative
  'Brewing',
  'Crafting',
  'Weaving',
  'Distilling',
  'Calibrating',
  'Crystallizing',
  'Sculpting',
  'Composing',
  'Orchestrating',
  'Harmonizing',
  'Curating',
  'Illuminating',
  'Unearthing',
  'Channeling',
  'Decoding',

  // Made up, in the same spirit
  'Combobulating',
  'Recombobulating',
  'Moo-sing',
  'Mooditating',
  'Cud-chewing',
  'Thinkifying',
  'Brainstorming',
  'Spelunking',
];

/** A random index other than `previous`, so the same verb never shows twice
 *  in a row. */
export function nextVerbIndex(
  previous: number,
  count: number,
  random: () => number = Math.random
): number {
  if (count <= 1) {
    return 0;
  }
  const step = 1 + Math.floor(random() * (count - 1));
  return (previous + step) % count;
}
